import { Link } from "react-router-dom";
import { AudioWaveform } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer data-testid="footer" className="border-t border-[#282C3D] bg-[#0E1018]">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-3 lg:px-8">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#E5A93C] text-[#0B0C10]">
              <AudioWaveform size={18} />
            </span>
            <span className="leading-tight">
              <span className="block font-display text-base font-bold text-slate-50">EVI-STUDIO</span>
              <span className="block font-mono text-[9px] uppercase tracking-widest text-slate-500">by Evinet.group</span>
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
            {t("Tailor-made custom songs, radio jingles and album productions — written, recorded and mastered in Switzerland.")}
          </p>
        </div>
        <div>
          <p className="eyebrow mb-4">Studio</p>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li><Link data-testid="footer-link-order" to="/order" className="transition-colors duration-200 hover:text-[#FFC857]">{t("Order a Song")}</Link></li>
            <li><Link data-testid="footer-link-private-events" to="/private-events" className="transition-colors duration-200 hover:text-[#FFC857]">{t("Private & Events")}</Link></li>
            <li><Link data-testid="footer-link-business" to="/business" className="transition-colors duration-200 hover:text-[#FFC857]">{t("Business & Jingles")}</Link></li>
            <li><Link data-testid="footer-link-album" to="/album" className="transition-colors duration-200 hover:text-[#FFC857]">{t("Album Production")}</Link></li>
            <li><Link data-testid="footer-link-contact" to="/contact" className="transition-colors duration-200 hover:text-[#FFC857]">{t("Contact")}</Link></li>
          </ul>
        </div>
        <div>
          <p className="eyebrow mb-4">{t("Legal")}</p>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li><Link data-testid="footer-link-privacy" to="/privacy" className="transition-colors duration-200 hover:text-[#FFC857]">{t("Privacy Policy")}</Link></li>
            <li><Link data-testid="footer-link-imprint" to="/imprint" className="transition-colors duration-200 hover:text-[#FFC857]">{t("Imprint")}</Link></li>
            <li><Link data-testid="footer-link-admin-payments" to="/admin/payments" className="transition-colors duration-200 hover:text-[#FFC857]">{t("Studio administration")}</Link></li>
          </ul>
          <p className="mt-6 font-mono text-xs text-slate-500">hello@evinet.group</p>
          <p className="font-mono text-xs text-slate-500">{t("Switzerland")}</p>
        </div>
      </div>
      <div className="border-t border-[#282C3D] py-5 text-center font-mono text-[11px] uppercase tracking-widest text-slate-600">
        {t("© 2026 Evinet.group — Evi-Studio. All rights reserved.")}
      </div>
    </footer>
  );
}
